import {
  ActiveFilterTemplate,
  AlcTypeFilterTemplate,
  BooleanFilterTemplate,
  CurrencyFilterTemplate,
  DateFilterTemplate,
  DayFilterTemplate,
  DecimalFilterTemplate,
  DelForProcessFilterTemplate,
  DeliveryStatusFilterTemplate,
  DeliveryTypeFilterTemplate,
  NumberFilterTemplate,
  OrderProcessFilterTemplate,
  PackagingIdentifierFilterTemplate,
  PackagingTypeFilterTemplate,
  PercentFilterTemplate,
  PriceFilterTemplate,
  ProjectFilterTemplate,
  PropertyIdentifierFilterTemplate,
  RoleFilterTemplate,
  StatusFilterTemplate,
  WeightUnitFilterTemplate,
} from '../../../../components/tableTemplates'
import { ColumnConfig } from '../../../../features/ui-config'
import { DropDownOptions } from '../ConfigurableTable'

export function getFilterTemplate(
  dataType: ColumnConfig['dataType'],
  dropDownOptions?: DropDownOptions,
) {
  switch (dataType) {
    case 'active':
      return ActiveFilterTemplate
    case 'alcType':
      return AlcTypeFilterTemplate
    case 'boolean':
      return BooleanFilterTemplate
    case 'currency':
      return CurrencyFilterTemplate
    case 'date':
    case 'forecastDate':
      return DateFilterTemplate
    case 'day':
      return DayFilterTemplate
    case 'decimal':
      return DecimalFilterTemplate
    case 'delForProcessCompletion':
    case 'delForProcessIsActive':
      return DelForProcessFilterTemplate
    case 'deliveryStatus':
      return DeliveryStatusFilterTemplate
    case 'deliveryType':
      return DeliveryTypeFilterTemplate
    case 'number':
      return NumberFilterTemplate
    case 'orderProcessCompletion':
    case 'orderProcessIsActive':
      return OrderProcessFilterTemplate
    case 'packagingIdentifier':
      return PackagingIdentifierFilterTemplate
    case 'packagingType':
      return PackagingTypeFilterTemplate
    case 'percent':
      return PercentFilterTemplate
    case 'price':
      return PriceFilterTemplate
    case 'project':
      return (options: any) =>
        ProjectFilterTemplate(options, dropDownOptions?.suppliers)
    case 'propertyIdentifier':
      return PropertyIdentifierFilterTemplate
    case 'role':
      return (options: any) =>
        RoleFilterTemplate(options, dropDownOptions?.roles)
    case 'status':
      return StatusFilterTemplate
    case 'unitOfWeight':
      return WeightUnitFilterTemplate
  }
}
